import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from '@mui/material';
import type { FC } from 'react';
import { useDeleteFacebookPage } from '../api/deleteFacebookPage';
import { useEnqueueSnackbar } from 'hooks';
import { useNavigate } from 'react-router';
import {
  createCabinetMutationTracking,
  trackCabinetSubmitAttempt,
} from 'lib/datadog';

interface DeleteFacebookPageProps {
  isOpen: boolean;
  close: () => void;
  id: number;
  name: string;
}

const DeleteFacebookPage: FC<DeleteFacebookPageProps> = (
  {
    isOpen,
    close,
    id,
    name,
  }) => {
  const { onShowErrorAlert, onShowAlert } = useEnqueueSnackbar();
  const navigate = useNavigate();

  const deleteFacebookPage = useDeleteFacebookPage({
    config: createCabinetMutationTracking({
      platform: 'facebook',
      entity: 'facebook_page',
      mode: 'delete',
      onSuccess: () => {
        onShowAlert('Facebook page deleted successfully');
        close();
        navigate('/cabinet/facebook/facebook-pages');
      },
      onError: (error) => {
        onShowErrorAlert(error.message || 'Failed to delete Facebook page');
      },
    }),
  });

  const handleDelete = () => {
    trackCabinetSubmitAttempt('facebook', 'facebook_page', 'delete', { id });
    deleteFacebookPage.mutate({ id });
  };

  return (
    <Dialog open={isOpen} onClose={close}>
      <DialogTitle>Delete Facebook Page</DialogTitle>
      <DialogContent>
        <DialogContentText>
          Are you sure you want to delete Facebook page &ldquo;{name}&rdquo;?
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={close}>Cancel</Button>
        <Button
          onClick={handleDelete}
          color="error"
          variant="contained"
          disabled={deleteFacebookPage.isPending}
        >
          Delete
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default DeleteFacebookPage;
